const moduleHome = {
	namespaced: true,
	state: {
		VOTE_ENABLE: false,
		MASK_ACTIVE: true,
		// ART_SUBMIT_ENABLE: process.env.VUE_APP_ART_SUBMIT_ENABLE === 'true',
		// COS_SUBMIT_ENABLE: process.env.VUE_APP_COS_SUBMIT_ENABLE === 'true',
		// ART_LIKES_ENABLE: process.env.VUE_APP_ART_LIKES_ENABLE === 'true',
		CUR_PAGENUM: sessionStorage.getItem('pagenum') || 1,
		RULES_POPUP_STATE: false
	},
	mutations: {
		SET_CUR_PAGENUM: (state, params) => {
			state.CUR_PAGENUM = params
			sessionStorage.setItem('pagenum', params)
		},
		SET_MASK_ACTIVE: (state, params) => {
			state.MASK_ACTIVE = params
		},
		SET_RULES_POPUP_STATE: (state, params) => {
			state.RULES_POPUP_STATE = params
		},
	},
	actions: {},
	getters: {},
}

export default moduleHome
